import CompanyPage from "@/app/(app)/settings/company/page";

export default function CompanySettingsPage() {
  return <CompanyPage />;
}
